import {
  HttpErrorResponse,
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpRequest,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { AuthService } from '../auth/auth.service';
import { TelemetryService } from '../observability/telemetry.service';

/**
 * - 401 (session expirée ou cookie invalide) : redirige vers /api/auth/login
 *   pour relancer le flow OIDC. Sauf pour /api/auth/me lui-même où le 401
 *   est attendu et géré par les guards.
 * - autres erreurs : log console + remontée télémétrie (→ Loki).
 */
export const errorInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
) => {
  const authService = inject(AuthService);
  const telemetry = inject(TelemetryService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      // Attributs HTTP communs (sans corps de réponse → pas de PII).
      const httpAttrs = {
        'http.request.method': req.method,
        'http.response.status_code': error.status,
        'url.path': req.url,
      };

      if (error.status === 401 && !req.url.endsWith('/api/auth/me')) {
        console.warn('[API] 401 - session expirée, redirection vers KC');
        telemetry.warn('api.session_expired', httpAttrs);
        authService.clear();
        authService.login();
      } else if (error.status === 403) {
        console.warn('[API] 403 - permission refusée');
        telemetry.warn('api.forbidden', httpAttrs);
      } else if (error.status === 0) {
        console.error('[API] Réseau - serveur injoignable');
        telemetry.error('api.network_unreachable', httpAttrs);
      } else if (error.status >= 500) {
        console.error(`[API] Erreur serveur ${error.status}:`, error.message);
        telemetry.error('api.server_error', httpAttrs);
      } else if (error.status >= 400) {
        console.warn(`[API] Erreur client ${error.status}:`, error.message);
        telemetry.warn('api.client_error', httpAttrs);
      }

      return throwError(() => error);
    }),
  );
};
